import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listBiddingSpotOperationLogs } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import {
  ListBiddingSpotOperationLogsRequestSchema,
  type ListBiddingSpotOperationLogsResponse,
} from '@ebalance/proto/bffuser/v1/bidding_spot_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * オペレーション履歴タブ (AC-BSP-038) の操作履歴を、 受渡日を指定して取得する hook。
 *
 * 通常入札とブロック入札の操作が 1 つの応答で返る。 申請取消・取下などの操作は別のタブで
 * 起こり、 タブのパネルは非選択でも mount されたままなので、 再取得は書き込み側の
 * invalidate (`spotApprovalRequestInvalidationKeys` / `blockApprovalRequestInvalidationKeys`
 * が `biddingQueryKeys.spotOperationLogs` を含む) で行う。
 *
 * fail-safe: 取得の失敗はタブ内のインライン表示に留め、 error boundary (= 全画面エラー) に
 * 飛ばさない ([[useGetBiddingSpotScreen]] と同じ理由)。
 */
export function useListBiddingSpotOperationLogs(
  deliveryDate: ProtoDate,
  options?: { enabled?: boolean },
): UseQueryResult<ListBiddingSpotOperationLogsResponse, ConnectError> {
  return useQuery(
    listBiddingSpotOperationLogs,
    create(ListBiddingSpotOperationLogsRequestSchema, { deliveryDate }),
    {
      enabled: options?.enabled,
      refetchOnMount: 'always',
      throwOnError: false,
    },
  )
}
